import { of } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "@legalzoom/order-sdk";
import * as i2 from "@legalzoom/business-formation-sdk";
export class OrderService {
    constructor(sdkOrderService, trackJsErrorLogService) {
        this.sdkOrderService = sdkOrderService;
        this.trackJsErrorLogService = trackJsErrorLogService;
    }
    prepareGetOrderById(context, appService, orderId, customerId, authToken, productName) {
        const that = this;
        return {
            name: 'prepareGetOrderById order.service' + context.constructor.name,
            pre: () => {
                return that.sdkOrderService.getOrdersById(orderId, customerId);
            },
            post: (response) => {
                const appState = appService.app;
                if (!!response) {
                    appState.orderId = response.order.orderId;
                    context.order = response.order;
                }
                else {
                    appState.orderId = 0;
                }
                appService.app = appState;
            },
            error: (error) => {
                console.log(error.message);
                this.trackJsErrorLogService.track(productName, 'order.service' + context.constructor.name, error);
                return of(null);
            }
        };
    }
}
OrderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function OrderService_Factory() { return new OrderService(i0.ɵɵinject(i1.OrderService), i0.ɵɵinject(i2.TrackJsErrorLogService)); }, token: OrderService, providedIn: "root" });
